import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { formatCurrency } from '../../../numberUtils';
import './ProjectLogisticsInfo.scss';
var renderEditLink = function renderEditLink(label, section, id, projectResourceId, permissions) {
  var permission = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'update';
  var className = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'required';
  var title = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var data = title ? {
    placement: 'bottom',
    toggle: 'tooltip'
  } : {};
  if (!permissions[permission]) {
    return /*#__PURE__*/React.createElement("h2", {
      className: "project-section-title"
    }, label);
  }
  var url = "/projects/".concat(projectResourceId, "/edit?from_project_page=true");
  if (section) {
    url = [url, "step=".concat(section)].join('&');
  }
  return /*#__PURE__*/React.createElement("a", {
    href: url,
    id: id,
    className: className,
    title: title,
    data: data
  }, label);
};
var handleStepNavigation = function handleStepNavigation(projectResourceId, permissions, title) {
  var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'start';
  return /*#__PURE__*/React.createElement(Fragment, null, permissions.update && /*#__PURE__*/React.createElement("a", {
    className: "edit-logistics-button",
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    title: title,
    href: "/projects/".concat(projectResourceId, "/edit?from_project_page=true&step=").concat(step)
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-edit"
  })));
};
var renderBudget = function renderBudget(projectResourceId, permissions, ownerOrCloraRep, project, hideBaseSalary, employerShareView, showHourlyRate) {
  var max = project.budget_maximum,
    min = project.budget_minimum,
    consultantMax = project.consultant_take_home_maximum,
    consultantMin = project.consultant_take_home_minimum,
    employmentType = project.employment_type,
    basePayHidden = project.base_pay_hidden;
  var budgetText = employmentType === 'full_time' ? 'Annual base salary range: ' : 'Hourly rate: ';
  var editLinkText = employmentType === 'full_time' ? 'Base Salary' : 'Hourly Rate';
  var budget = max && min ? "".concat(formatCurrency(min, 0), " - ").concat(formatCurrency(max, 0)) : null;
  var consultantBudget = consultantMax && consultantMin ? "".concat(formatCurrency(consultantMin, 0), " - ").concat(formatCurrency(consultantMax, 0)) : null;
  var hideBudget = (basePayHidden || hideBaseSalary) && employmentType === 'full_time';
  return /*#__PURE__*/React.createElement(Fragment, null, ownerOrCloraRep && permissions.update ? /*#__PURE__*/React.createElement("div", {
    className: "commitment hourly-rate"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-dollar-sign me-3"
  }), budget ? "".concat(budgetText, " ").concat(budget, " ").concat(basePayHidden ? '(Hidden from candidates)' : '') : renderEditLink(editLinkText, 'logistics', null, projectResourceId, permissions, 'update'), handleStepNavigation(projectResourceId, permissions, 'Edit Logistics', 'logistics')) : !hideBudget && budget && showHourlyRate && /*#__PURE__*/React.createElement("div", {
    className: "commitment hourly-rate"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-dollar-sign me-3"
  }), "".concat(budgetText, " ").concat(employerShareView ? budget : consultantBudget)));
};
var renderDurationAndHoursPerWeek = function renderDurationAndHoursPerWeek(projectResourceId, permissions, ownerOrCloraRep, project) {
  var avgTimeRequiredRange = project.avg_time_required_range,
    durationRange = project.duration_range,
    avgTimeRequiredText = project.avg_time_required_text,
    durationWithPrefixText = project.duration_with_prefix_text,
    durationText = project.duration_text;
  var showEditLink = !avgTimeRequiredRange && !durationRange;
  var hoursPerWeekText = avgTimeRequiredText || "".concat(avgTimeRequiredRange, " hours per week");
  var durationRangeText = durationWithPrefixText || (durationText ? "for ".concat(durationText) : "for ".concat(durationRange, " ").concat(durationRange > 1 ? 'months' : 'month'));
  return /*#__PURE__*/React.createElement(Fragment, null, ownerOrCloraRep && permissions.update ? /*#__PURE__*/React.createElement("div", {
    className: "commitment duration"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-calendar-day me-3"
  }), showEditLink ? renderEditLink('Duration and Average Time', 'start', null, projectResourceId, permissions, 'update') : "".concat(hoursPerWeekText, " ").concat(durationRangeText), handleStepNavigation(projectResourceId, permissions, 'Edit Logistics')) : !showEditLink && /*#__PURE__*/React.createElement("div", {
    className: "commitment duration"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-calendar-day me-3"
  }), hoursPerWeekText, ' ', durationRangeText));
};
var renderLocationAndWorktype = function renderLocationAndWorktype(projectResourceId, permissions, ownerOrCloraRep, project) {
  return /*#__PURE__*/React.createElement(Fragment, null, ownerOrCloraRep && permissions.update ? /*#__PURE__*/React.createElement("div", {
    className: "commitment work-location"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-map-marker-alt me-3"
  }), project.work_location ? "".concat(project.office_and_worktype_information) : renderEditLink('Edit Logistics', 'start', null, projectResourceId, permissions, 'update'), handleStepNavigation(projectResourceId, permissions, 'Edit Logistics', 'logistics')) : project.work_location && /*#__PURE__*/React.createElement("div", {
    className: "commitment work-location"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-map-marker-alt me-3"
  }), "".concat(project.office_and_worktype_information)));
};
var renderSeniority = function renderSeniority(projectResourceId, permissions, ownerOrCloraRep, project) {
  return /*#__PURE__*/React.createElement(Fragment, null, ownerOrCloraRep && permissions.update ? /*#__PURE__*/React.createElement("div", {
    className: "commitment seniority"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-certificate me-3"
  }), project.seniority && project.seniority.length ? "".concat(project.level_names, " Level") : renderEditLink('Experience Levels', 'start', null, projectResourceId, permissions, 'update'), handleStepNavigation(projectResourceId, permissions, 'Edit Seniority')) : project.seniority && project.seniority.length ? /*#__PURE__*/React.createElement("div", {
    className: "commitment seniority"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-certificate me-3"
  }), "".concat(project.level_names, " Level")) : '');
};
var renderTravelRequirement = function renderTravelRequirement(projectResourceId, permissions, ownerOrCloraRep, project) {
  return /*#__PURE__*/React.createElement(Fragment, null, ownerOrCloraRep && permissions.update ? /*#__PURE__*/React.createElement("div", {
    className: "commitment travel"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-plane"
  }), "Travel Requirements: ".concat(project.travel_location_names ? project.travel_location_names : 'N/A'), handleStepNavigation(projectResourceId, permissions, 'Edit Logistics', 'logistics')) : project.travel_location_names && /*#__PURE__*/React.createElement("div", {
    className: "commitment travel"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-plane"
  }), "Travel Requirements: ".concat(project.travel_location_names)));
};
var renderCompensationAndBenefits = function renderCompensationAndBenefits(projectResourceId, permissions, ownerOrCloraRep, project) {
  return /*#__PURE__*/React.createElement(Fragment, null, ownerOrCloraRep && permissions.update ? /*#__PURE__*/React.createElement("div", {
    className: "commitment travel"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-info-circle"
  }), "Compensation & Benefits: ".concat(project.compensation_benefit_note ? project.compensation_benefit_note : 'N/A'), handleStepNavigation(projectResourceId, permissions, 'Edit Logistics', 'logistics')) : project.compensation_benefit_note && /*#__PURE__*/React.createElement("div", {
    className: "commitment travel"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-info-cirle"
  }), "Travel Requirements: ".concat(project.compensation_benefit_note)));
};
function ProjectLogisticsInfo(_ref) {
  var projectResourceId = _ref.projectResourceId,
    _ref$permissions = _ref.permissions,
    permissions = _ref$permissions === void 0 ? {} : _ref$permissions,
    _ref$ownerOrCloraRep = _ref.ownerOrCloraRep,
    ownerOrCloraRep = _ref$ownerOrCloraRep === void 0 ? false : _ref$ownerOrCloraRep,
    project = _ref.project,
    _ref$hideBaseSalary = _ref.hideBaseSalary,
    hideBaseSalary = _ref$hideBaseSalary === void 0 ? false : _ref$hideBaseSalary,
    _ref$employerShareVie = _ref.employerShareView,
    employerShareView = _ref$employerShareVie === void 0 ? false : _ref$employerShareVie,
    isCollaborator = _ref.isCollaborator,
    showHourlyRate = _ref.showHourlyRate;
  return /*#__PURE__*/React.createElement("div", {
    className: "project-logistics-info"
  }, renderSeniority(projectResourceId, permissions, ownerOrCloraRep, project), project.employment_type === 'consulting' && renderDurationAndHoursPerWeek(projectResourceId, permissions, ownerOrCloraRep, project), renderLocationAndWorktype(projectResourceId, permissions, ownerOrCloraRep, project), renderTravelRequirement(projectResourceId, permissions, ownerOrCloraRep, project), !isCollaborator && renderBudget(projectResourceId, permissions, ownerOrCloraRep, project, hideBaseSalary, employerShareView, showHourlyRate), project.employment_type === 'full_time' && renderCompensationAndBenefits(projectResourceId, permissions, ownerOrCloraRep, project));
}
ProjectLogisticsInfo.propTypes = {
  project: PropTypes.shape({}).isRequired,
  projectResourceId: PropTypes.string.isRequired,
  permissions: PropTypes.shape({}),
  ownerOrCloraRep: PropTypes.bool,
  hideBaseSalary: PropTypes.bool,
  employerShareView: PropTypes.bool
};
export default ProjectLogisticsInfo;